import React, { FC } from 'react'
import * as ModalStyles from '../../../../../../ModalWindow/modal.styles'
import { DatasetQuestion } from '../../trained_questions/dataset-question'

interface DatasetQuestionSectionWithoutRelevantQuestionProps {
  question: string
  answer: string
  onCreateNewQuestion: (question: string, answer: string) => void
  onQuestionWasChanged?: (active: boolean) => void
}

export const DatasetQuestionSectionWithoutRelevantQuestion: FC<DatasetQuestionSectionWithoutRelevantQuestionProps> = ({
  question,
  answer,
  onCreateNewQuestion,
  onQuestionWasChanged,
}) => {
  return (
    <ModalStyles.ModalContainerSection style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <DatasetQuestion
        question={question}
        answer={answer}
        questionType={'main'}
        createQuestionCallback={onCreateNewQuestion}
        onQuestionWasChanged={onQuestionWasChanged}
      />
    </ModalStyles.ModalContainerSection>
  )
}
